(function () {
  function init() {
    var article = document.querySelector(".pseo-article");
    var content = document.querySelector("[data-pseo-content]");
    if (article) initColors(article);
    if (content) {
      wrapTables(content);
      initToc(content);
    }
    initProgress(content);
    initStickyCta();
  }
  function isTransparent(c) {
    return !c || c === "transparent" || /rgba\([^)]*,\s*0\)$/.test(c);
  }
  function initColors(article) {
    var ink = getComputedStyle(article).color;
    var node = article;
    var paper = "";
    while (node && node.nodeType === 1) {
      var bg = getComputedStyle(node).backgroundColor;
      if (!isTransparent(bg)) { paper = bg; break; }
      node = node.parentElement;
    }
    if (ink) article.style.setProperty("--pseo-ink", ink);
    if (paper) article.style.setProperty("--pseo-paper", paper);
  }
  function wrapTables(content) {
    var tables = content.querySelectorAll("table");
    for (var i = 0; i < tables.length; i++) {
      var t = tables[i];
      if (t.parentElement && t.parentElement.classList.contains("pseo-table-wrap")) continue;
      var wrap = document.createElement("div");
      wrap.className = "pseo-table-wrap";
      t.parentNode.insertBefore(wrap, t);
      wrap.appendChild(t);
    }
  }
  function slugify(text, i) {
    var slug = (text || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .slice(0, 60);
    return slug || "section-" + i;
  }
  function tocHtml(items, withTitle) {
    var html = withTitle ? '<p class="pseo-toc-title">In this article</p>' : "";
    html += '<ul class="pseo-toc-list">';
    for (var j = 0; j < items.length; j++) {
      html += '<li><a class="pseo-toc-link" href="#' + items[j].id + '">' + escapeHtml(items[j].text) + "</a></li>";
    }
    return html + "</ul>";
  }
  function initToc(content) {
    var headings = content.querySelectorAll("h2");
    var desktop = document.querySelector("[data-pseo-toc]");
    var mobile = document.querySelector("[data-pseo-toc-mobile]");
    var mobileList = document.querySelector("[data-pseo-toc-mobile-list]");
    if (headings.length < 2) {
      var sidebar = desktop && desktop.closest(".pseo-sidebar");
      if (sidebar) sidebar.style.display = "none";
      return;
    }
    var items = [];
    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      if (!h.id) h.id = slugify(h.textContent, i);
      items.push({ id: h.id, text: (h.textContent || "").trim(), el: h });
    }
    if (desktop) desktop.innerHTML = tocHtml(items, true);
    if (mobile && mobileList) {
      mobileList.innerHTML = tocHtml(items, false);
      mobile.hidden = false;
      mobileList.addEventListener("click", function (e) {
        if (e.target && e.target.classList && e.target.classList.contains("pseo-toc-link")) mobile.open = false;
      });
    }
    var links = document.querySelectorAll(".pseo-toc-link");
    var ticking = false;
    function update() {
      ticking = false;
      var current = items[0].id;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el.getBoundingClientRect().top <= 140) current = items[i].id;
        else break;
      }
      for (var k = 0; k < links.length; k++) {
        links[k].classList.toggle("is-active", links[k].getAttribute("href") === "#" + current);
      }
    }
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }
  function initProgress(content) {
    var bar = document.querySelector("[data-pseo-progress]");
    if (!bar || !content) return;
    function onScroll() {
      var rect = content.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var pct = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      bar.style.transform = "scaleX(" + pct + ")";
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  function initStickyCta() {
    var cta = document.querySelector("[data-pseo-sticky]");
    if (!cta) return;
    function onScroll() {
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;
      var pct = window.scrollY / docHeight;
      if (pct > 0.3) cta.classList.add("is-visible");
      else cta.classList.remove("is-visible");
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
